import _slicedToArray from "C:\\Users\\Administrator\\Desktop\\KaporgLatestC\\KAPorg-frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import { useContext } from 'react';
import { genStyleUtils } from '@ant-design/cssinjs-utils';
import { ConfigContext, defaultIconPrefixCls } from '../../config-provider/context';
import { genCommonStyle, genLinkStyle, genIconStyle } from '../../style';
import useLocalToken, { unitless } from '../useToken';
var _genStyleUtils = genStyleUtils({
    usePrefix: function usePrefix() {
      var _useContext = useContext(ConfigContext),
        getPrefixCls = _useContext.getPrefixCls,
        iconPrefixCls = _useContext.iconPrefixCls;
      var rootPrefixCls = getPrefixCls();
      return {
        rootPrefixCls: rootPrefixCls,
        iconPrefixCls: iconPrefixCls
      };
    },
    useToken: function useToken() {
      var _useLocalToken = useLocalToken(),
        _useLocalToken2 = _slicedToArray(_useLocalToken, 5),
        theme = _useLocalToken2[0],
        realToken = _useLocalToken2[1],
        hashId = _useLocalToken2[2],
        token = _useLocalToken2[3],
        cssVar = _useLocalToken2[4];
      return {
        theme: theme,
        realToken: realToken,
        hashId: hashId,
        token: token,
        cssVar: cssVar
      };
    },
    useCSP: function useCSP() {
      var _useContext2 = useContext(ConfigContext),
        csp = _useContext2.csp;
      return csp !== null && csp !== void 0 ? csp : {};
    },
    getResetStyles: function getResetStyles(token, config) {
      var _a;
      return [{
        '&': genLinkStyle(token)
      }, genIconStyle((_a = config === null || config === void 0 ? void 0 : config.prefix.iconPrefixCls) !== null && _a !== void 0 ? _a : defaultIconPrefixCls)];
    },
    getCommonStyle: genCommonStyle,
    getCompUnitless: function getCompUnitless() {
      return unitless;
    }
  }),
  genStyleHooks = _genStyleUtils.genStyleHooks,
  genComponentStyleHook = _genStyleUtils.genComponentStyleHook,
  genSubStyleComponent = _genStyleUtils.genSubStyleComponent;
export { genStyleHooks, genComponentStyleHook, genSubStyleComponent };